var map = {
	"./app.js": "d9cd",
	"./cart.js": "499b",
	"./errorLog.js": "4d49",
	"./permission.js": "31c2",
	"./settings.js": "0781",
	"./tagsView.js": "7509",
	"./user.js": "0f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";